import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NftService } from 'app/sections/nft/services/nft.service';

@Component({
  selector: '[app-wallet]',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WalletComponent implements OnInit {

  public selectedWallet: string = null;

  constructor(
    private nftService: NftService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.nftService.selectedWalletInfo.subscribe((wallet: string)=>{
      this.selectedWallet = wallet;
    });
  }

  gotoWallet(){
    this.nftService.setWallet(this.selectedWallet);
    this.router.navigate(['nft/wallet', this.selectedWallet])
  }

}
